// src/components/Tariffs/Tariffs.jsx
import React, { useState } from 'react';
import './css/Tariffs.css';

import ProductOrange from '../../img/product.png';
import ProductBlue from '../../img/product.png';
import ProductGreen from '../../img/product.png';

import Registry from '../Registry/Registry';
import ApplicationPopup from '../Popup/ApplicationPopup';

const Tariffs = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedTariff, setSelectedTariff] = useState('');

  const tariffs = [
    {
      name: 'Базовый',
      description: 'Подходит для небольших организаций с ограниченным объемом данных.',
      stations: '50 станций',
      priceRange: 'от 100 000 ₽ до 350 000 ₽',
      priceNote: 'Цена зависит от количества станций и срока лицензии',
      features: [
        'Расширенные отметки',
        'Доступ к обновлениям',
        'Круглосуточная поддержка',
      ],
      icon: ProductOrange,
    },
    {
      name: 'Стандарт',
      description: 'Идеален для средних компаний с растущими потребностями.',
      stations: '100 станций',
      priceRange: 'от 350 000 ₽ до 500 000 ₽',
      priceNote: 'Цена зависит от количества станций, срока лицензии и дополнительных услуг',
      features: [
        'Расширенные отметки',
        'Доступ к обновлениям',
        'Круглосуточная поддержка',
        'Приоритетная техподдержка',
      ],
      icon: ProductBlue,
    },
    {
      name: 'Профессионал',
      description: 'Максимальная производительность для крупных предприятий.',
      stations: '200 станций',
      priceRange: 'от 500 000 ₽ до 900 000 ₽',
      priceNote: 'Цена зависит от количества станций, срока лицензии и объема интеграций',
      features: [
        'Расширенные отметки',
        'Доступ к обновлениям',
        'Круглосуточная поддержка',
        'Выделенный менеджер',
        'API и интеграции',
      ],
      icon: ProductGreen,
    },
  ];

  const handleOpenPopup = (tariffName = 'Индивидуальный') => {
    setSelectedTariff(tariffName);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setSelectedTariff('');
  };

  return (
    <section className="tariffs" id="tariffs">
      <div className="container tariffs__container">
        <div className="h2-background">
          <h2 className="tariffs_title">Лицензии</h2>
        </div>

        <div className="tariffs__grid">
          {tariffs.map((tariff, index) => (
            <div key={index} className="tariff-card">
              <div className="tariff-card__header">
                <img
                  src={tariff.icon}
                  alt={tariff.name}
                  className="tariff-card__icon"
                />
                <div className="tariff-card__title-wrapper">
                  <h3 className="tariff-card__name">{tariff.name}</h3>
                  <p className="tariff-card__description">{tariff.description}</p>
                </div>
              </div>

              <div className="tariff-card__stations">{tariff.stations}</div>
              
              {/* Блок с ценой */}
             

              <ul className="tariff-card__features">
                {tariff.features.map((feature, i) => (
                  <li key={i} className="tariff-card__feature">
                    <span className="tariff-card__check">—</span> {feature}
                  </li>
                ))}
              </ul>
              <div className="tariff-card__price">
                <div className="tariff-card__price-note">{tariff.priceNote}</div>
                <div className="tariff-card__price-range">{tariff.priceRange}</div>
                
              </div>
              <button 
                className="tariff-card__btn"
                onClick={() => handleOpenPopup(tariff.name)}
              >
                Уточнить условия
              </button>
            </div>
          ))}
        </div>

        {/* Карточка «Индивидуальный тариф» */}
        <div className="tariff-card tariff-card--custom">
          <div className="tariff-card__custom-content">
            <div className="tariff-card__custom-group">
              <img
                src={ProductGreen}
                alt="Индивидуальный тариф"
                className="tariff-card__icon"
              />
              <div className="tariff-card__custom-left">
                <p className="tariff-card__custom-text">Индивидуальный расчёт</p>
                <p className="tariff-card__custom-subtext">
                  <span className="tariff-card__price-note">
                    Цена зависит от масштаба проекта, технических требований и объема кастомизации
                  </span>
                  Стоимость: от 300 000 ₽ 
                  <br />
                  
                </p>
              </div>
            </div>
            <button 
              className="tariff-card__btn"
              onClick={() => handleOpenPopup('Индивидуальный расчёт')}
            >
              Уточнить условия
            </button>
          </div>
        </div>

        <Registry />
      </div>

      <ApplicationPopup 
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        type={`Лицензия-${selectedTariff.toLowerCase()}`}
        title={`Уточнить условия - ${selectedTariff}`}
      />
    </section>
  );
};

export default Tariffs;